import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  height: 100vh;
`

export { Container }
